import React from "react";
import { OrderDtoPaymentTypeEnum, OrderItemDto } from "../api";

export interface CartContextSchema {
  cart: OrderItemDto[];
  paymentType?: OrderDtoPaymentTypeEnum;
  note?: string;
  setPaymentType: (type: OrderDtoPaymentTypeEnum | undefined) => void;
  setNote: (note: string | undefined) => void;
  addItem: (item: OrderItemDto) => void;
  updateItem: (item: OrderItemDto) => void;
  removeItem: (ean: string) => void;
  refreshCart: () => void;
  resetCartSoft: () => void;
  resetCartHard: () => void;
}

export const CartContext = React.createContext<CartContextSchema>({} as CartContextSchema);
